<template>
	<div>
		<div
			class="modal fade modal-fullscreen-mobile"
			ref="modal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
		>
			<div class="modal-dialog vld-parent" role="document">
				<div class="modal-content">
					<div class="modal-header modal-header-banner">
						<button
							class="button button-transparent button-modal-back"
							@click="close"
						>
							<i class="sk-icon-times"></i>
						</button>
						<div>
							<h1>Create Your Account</h1>
						</div>
						<div class="header-description">
							Fill in your details to finish creating your account
							and start taking advantage of your new ammenity!
						</div>
						<img src="/images/2k-phone.png" alt="Phone" />
					</div>
					<div class="modal-body">
						<loading :active="loading" />
						<button
							class="button button-transparent button-modal-back"
							@click="close"
						>
							<i class="sk-icon-long-arrow-left-regular"></i>
						</button>
						<div class="modal-inner-content">
							<div class="account-inputs">
								<div>
									<SkInput
										:ref="'nameInput'"
										:name="'Full Name'"
										:placeholder="'John Smith'"
										:required="true"
										v-model="name"
									/>
									<SkInput
										:ref="'emailInput'"
										:name="'Email'"
										:type="'email'"
										:placeholder="'jsmith@gmail.com'"
										:required="true"
										:validation="emailRegex"
										v-model="email"
									/>
									<SkInput
										:name="'Apartment Number'"
										:placeholder="'55F'"
										v-model="aptNumber"
									/>
								</div>
							</div>
							<button
								class="button button-primary"
								@click="clickContinue"
							>
								Create Account
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-body {
	justify-content: flex-start;
	background: var(--sk-grey-bg);
}

.modal-header {
	flex-direction: column;
}

.modal-header-banner {
	height: 100%;
	padding: 20px;
	justify-content: flex-start;
	max-height: 335px;
	min-height: 100px;
}

.modal-header-banner > div {
	margin: 0 auto;
	display: block;
}

.modal-header-banner h1,
.modal-header-banner .header-description {
	color: var(--gR-white);
}

.modal-header-banner h1 {
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 12px;
}

.modal-header-banner img {
	margin: 48px auto;
	display: block;
	object-fit: contain;
	max-height: 140px;
	min-height: 40px;
	height: auto;
	width: auto;
}

.modal-header-banner .header-description {
	font-size: 12px;
}

.modal-inner-content {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.account-inputs {
	margin-top: 10px;
	margin-bottom: 30px;
	flex-shrink: 1;
	display: flex;
	align-items: center;
	width: 100%;
}

.account-inputs > div {
	width: 100%;
}

.account-inputs .sk-input-wrapper:not(:last-child) {
	margin-bottom: 20px;
}

.modal-inner-content,
.account-inputs >>> .sk-input-wrapper,
.modal-inner-content .button,
.modal-header-banner > div {
	max-width: 335px !important;
	width: 100% !important;
}

.account-inputs >>> .sk-input-wrapper {
	min-height: 50px;
}

.modal-inner-content .button {
	flex-shrink: 0;
}

@media only screen and (max-height: 675px) {
	.modal-header-banner img {
		margin-bottom: 0;
		margin-top: 20px;
	}
}

@media only screen and (max-height: 550px) {
	.modal-body {
		flex-shrink: 0;
	}

	.modal-header-banner img {
		display: none;
	}
}
</style>

<script>
import SkInput from "@/components/common/SkInput.vue"
import Loading from "vue-loading-overlay"
import { eventBus } from "@/eventBus"
import { NotificationType } from "@/enums/NotificationType"
import { EventBusEvents } from "@/enums/EventBusEvents"

export default {
	name: "CreateAccountModal",
	components: {
		SkInput,
		Loading
	},
	data: function () {
		return {
			isOpen: false,
			emailRegex:
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			name: "",
			email: "",
			aptNumber: "",
			loading: false
		}
	},
	computed: {},
	methods: {
		open() {
			this.isOpen = true
			this.loading = false
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Activation Modal Opened"
			})
			this.name = this.$store.state.user.username
			this.email = this.$store.state.user.email
			this.aptNumber =
				this.$store.state.user.table != undefined ||
				this.$store.state.user.table != null
					? this.$store.state.user.table
					: ""
			$(this.$refs.modal).modal("show")
		},
		async clickContinue() {
			try {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "User Profile Activate Clicked"
				})
				this.loading = true
				const validName = this.$refs.nameInput.validate()
				const validEmail = this.$refs.emailInput.validate()
				if (validName && validEmail) {
					const result = await this.$store.dispatch("activateUser", {
						first_name: this.name,
						email: this.email,
						apartment_number: this.aptNumber
					})
					if (result.status && result.status != 200) {
						const message = result.code
							? result.message
							: "Something went wrong, please try again"
						eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
							message: message,
							type: NotificationType.ERROR
						})
						throw result.e
					} else if (result) {
						this.close(true)
					}
				} else {
					this.$store.dispatch("sendMixpanelEvent", {
						msg: "User Details Invalid",
						data: {
							email: this.email,
							name: this.email
						}
					})
					throw `Invalid User Details, email: ${this.email}, username: ${this.name}`
				}
			} catch (e) {
				this.loading = false
				throw e
			}
		},
		close(result) {
			this.emitResult(result)
			$(this.$refs.modal).modal("hide")
		},
		emitResult(result) {
			if (this.isOpen) {
				this.$emit("onResult", result)
				this.isOpen = false
			}
		}
	},
	mounted: function () {
		$(this.$refs.modal).on("hidden.bs.modal", () => {
			this.emitResult(false)
		})
	}
}
</script>
